// Import model
import { CarpetCatalogItemCondition } from '../models/CarpetCatalogItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CarpetCatalogItemIndexedFields } from '../models/CarpetCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CarpetCatalogItemIndexedFieldsSerializer } from './CarpetCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CarpetCatalogItemCondition - handles JSON serialization and deserialization with type validation
 */
export class CarpetCatalogItemConditionSerializer {
  /**
   * Deserializes a JSON string into a CarpetCatalogItemCondition instance
   */
  static deserialize(json: string): CarpetCatalogItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CarpetCatalogItemCondition instance
   */
  static fromObject(obj: any): CarpetCatalogItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CarpetCatalogItemCondition');
    }


    const instance: CarpetCatalogItemCondition = {
      fieldName: obj['fieldName'] as CarpetCatalogItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CarpetCatalogItemCondition instances
   */
  static deserializeArray(json: string): CarpetCatalogItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CarpetCatalogItemCondition instance to a JSON string
   */
  static serialize(instance: CarpetCatalogItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CarpetCatalogItemCondition instance to a plain object
   */
  static toObject(instance: CarpetCatalogItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CarpetCatalogItemCondition instances to a JSON string
   */
  static serializeArray(instances: CarpetCatalogItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
